import { getRemainingRoute } from "@poscon/shared-types";
import { useMemo } from "react";
export const useRouteFixes = (fp, ppos = null) => {
    let fixes = fp.convertedRoute;
    return useMemo(() => {
        if (!ppos || !fixes) {
            return fixes;
        }
        try {
            return getRemainingRoute(ppos, fixes).fixes;
        }
        catch (e) {
            console.error("Error getting remaining route", e);
            return fixes;
        }
    }, [ppos, fixes]);
};
//# sourceMappingURL=navdataApi.js.map